import React from 'react'
import { Row, Col } from 'antd'
import PaspolLogo from '../img/logo_new_2.png'

export default class Header extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hideNav: ''
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize() {
    this.setState({hideNav: window.innerWidth <= 760});
  }

  render () {
    let pos = ''
    let marg = {}
    if (window.innerWidth <= 480) {
      pos = 'inherit'
      marg = {
        marginLeft: '10px'
      }
    } else {
      pos = 'absolute'
    }
    return (
      <div style={{height: '50px', backgroundColor: '#eee', display: 'flex'}} className='header'>
        <img alt='logo' src={PaspolLogo} style={{marginTop: '5px', width: 'auto', height: '38px'}} />
        <div style={{position: pos, right: '10px', top: '15px', width: '400px'}}>
          <Row style={marg}>
            <Col xs={12} sm={12} md={12} lg={12} xl={24}>
              <p style={{float: 'left', marginRight: '10px', fontSize: '12px'}}>
                <i className="fa fa-phone fa-lg"></i> Phone <strong>021 3044 8080</strong>
              </p>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={24}>
              <p style={{float: 'left', fontSize: '12px'}}>
                <i className="fa fa-whatsapp fa-lg"></i> Whatsapp <strong>0877 0017 8000</strong>
              </p>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/common/header.js